module.exports = __webpack_public_path__ + "media/images/reviews/yelp_review-d0da07fd5e2aea5113a183c1fb08f61b.png";